module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/storefront-a65e3d3cbefdea08de3ed5021cfb6439.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/storefront.svg
// module id = 44UC
// module chunks = 24